import callAPI from "../callApi";
import path from "../variables";

const Contracts = {
	getByPersonal: (personalId: number) =>
		callAPI("GET", `${path.base}/contracts/personal/${personalId}`, "", "listing contracts"),
	show: (contractId: number) =>
		callAPI("GET", `${path.base}/contracts/${contractId}`, "", "getting contract"),
	create: (data: any) =>
		callAPI("POST", `${path.base}/contracts`, data, "creating contract"),
	update: (contractId: number, data: any) =>
		callAPI("PUT", `${path.base}/contracts/${contractId}`, data, "updating contract"),
	endContract: (contractId: number, date_end: string) =>
		callAPI("POST", `${path.base}/contracts/${contractId}/end`, { date_end }, "ending contract"),
	remove: (contractId: number) =>
		callAPI("DELETE", `${path.base}/contracts/${contractId}`, "", "removing contract"),
};

export default Contracts;
